<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>
      </div>
      <div class="col-md fieldset">
        <div class="row">
          <app-form-group label="First vessel type">
            <app-select [(ngModel)]="exemption.firstVesselType" (ngModelChange)="resetVesselInfoFirst()"
                        id="firstVesselType" [options]="vesselTypes"
                        [formatter]="vesselTypesFormatter" required>
            </app-select>
          </app-form-group>
          @if (exemption.firstVesselType === 'IMO') {
            <app-form-group>
              <app-info class="formGroupLabel">
                <label>First vessel name/IMO number</label>
                <div class="tooltipContent">Name of moored vessel 1</div>
              </app-info>
              <app-search [(ngModel)]="firstVessel" (ngModelChange)="onVesselChangeWithPrefix('first', firstVessel)"
                          [searchFunction]="searchVessel" [inputFormatter]="vesselNameFormatter"
                          [minCharacters]="3" dataKey="imoCode" id="firstVessel">
              </app-search>
            </app-form-group>
          }
        </div>
        <div class="row">
          @if (exemption.firstVesselType === 'IMO') {
            <app-form-group label="First vessel name">
              <input [(ngModel)]="exemption.firstVesselNameIMO" id="firstVesselNameIMO" type="text"
                     maxlength="64"
                     class="form-control" readonly required>
            </app-form-group>
          }
          @if (exemption.firstVesselType === 'IMO') {
            <app-form-group label="First vessel IMO">
              <input [(ngModel)]="exemption.firstVesselIMO" id="firstVesselIMO" type="text" maxlength="64"
                     class="form-control" readonly required>
            </app-form-group>
          }
          @if (exemption.firstVesselType === 'ENI') {
            <app-form-group label="First vessel name">
              <input [(ngModel)]="exemption.firstVesselNameENI" id="firstVesselNameENI" type="text"
                     maxlength="64" class="form-control" required>
            </app-form-group>
          }
          @if (exemption.firstVesselType === 'ENI') {
            <app-form-group label="First vessel ENI">
              <input [(ngModel)]="exemption.firstVesselENI" id="firstVesselENI" type="text" maxlength="64"
                     class="form-control" required>
            </app-form-group>
          }
        </div>

        @if (exemption.firstVesselType) {
          <div>
            <div class="row">
              <div class="label mb-2">First vessel berthing/admission time</div>
            </div>
            <div class="row">
              <app-form-group>
                <app-info class="formGroupLabel">
                  <label>From</label>
                  <div class="tooltipContent">From when the vessel is berthed next to the ‘base vessel’</div>
                </app-info>
                <app-date-field [(ngModel)]="exemption.firstVesselFrom" id="firstVesselFrom" required></app-date-field>
              </app-form-group>
              <app-form-group>
                <app-info class="formGroupLabel">
                  <label>To</label>
                  <div class="tooltipContent">To when the vessel is berthed next to the ‘base vessel’</div>
                </app-info>
                <app-date-field [(ngModel)]="exemption.firstVesselTo" id="firstVesselTo" required></app-date-field>
              </app-form-group>
            </div>
            <div class="row">
              <app-form-group label="Second vessel type">
                <app-select [(ngModel)]="exemption.secondVesselType" (ngModelChange)="resetVesselInfoSecond()"
                            id="secondVesselType" [options]="vesselTypes"
                            [formatter]="vesselTypesFormatter">
                </app-select>
              </app-form-group>
              @if (exemption.secondVesselType === 'IMO') {
                <app-form-group>
                  <app-info class="formGroupLabel">
                    <label>Second vessel name/IMO number</label>
                    <div class="tooltipContent">Name of moored vessel 2</div>
                  </app-info>
                  <app-search [(ngModel)]="secondVessel"
                              (ngModelChange)="onVesselChangeWithPrefix('second', secondVessel)"
                              [searchFunction]="searchVessel" [inputFormatter]="vesselNameFormatter"
                              [minCharacters]="3" dataKey="imoCode" id="secondVessel">
                  </app-search>
                </app-form-group>
              }
            </div>
            <div class="row">
              @if (exemption.secondVesselType === 'IMO') {
                <app-form-group label="Second vessel name">
                  <input [(ngModel)]="exemption.secondVesselNameIMO" id="secondVesselNameIMO" type="text"
                         maxlength="64"
                         class="form-control" readonly required>
                </app-form-group>
              }
              @if (exemption.secondVesselType === 'IMO') {
                <app-form-group label="Second vessel IMO">
                  <input [(ngModel)]="exemption.secondVesselIMO" id="secondVesselIMO" type="text" maxlength="64"
                         class="form-control" readonly required>
                </app-form-group>
              }
              @if (exemption.secondVesselType === 'ENI') {
                <app-form-group label="Second vessel name">
                  <input [(ngModel)]="exemption.secondVesselNameENI" id="secondVesselNameENI" type="text"
                         maxlength="64" class="form-control" required>
                </app-form-group>
              }
              @if (exemption.secondVesselType === 'ENI') {
                <app-form-group label="Second vessel ENI">
                  <input [(ngModel)]="exemption.secondVesselENI" id="secondVesselENI" type="text" maxlength="64"
                         class="form-control" required>
                </app-form-group>
              }
            </div>
          </div>
        }

        @if (exemption.secondVesselType) {
          <div>
            <div class="row">
              <div class="label mb-2">Second vessel berthing/admission time</div>
            </div>
            <div class="row">
              <app-form-group>
                <app-info class="formGroupLabel">
                  <label>From</label>
                  <div class="tooltipContent">From when the vessel is berthed next to the ‘base vessel’</div>
                </app-info>
                <app-date-field [(ngModel)]="exemption.secondVesselFrom" id="secondVesselFrom"
                                required></app-date-field>
              </app-form-group>
              <app-form-group>
                <app-info class="formGroupLabel">
                  <label>To</label>
                  <div class="tooltipContent">To when the vessel is berthed next to the ‘base vessel’</div>
                </app-info>
                <app-date-field [(ngModel)]="exemption.secondVesselTo" id="secondVesselTo" required></app-date-field>
              </app-form-group>
            </div>
            <div class="row">
              <app-form-group label="Third vessel type">
                <app-select [(ngModel)]="exemption.thirdVesselType" (ngModelChange)="resetVesselInfoThird()"
                            id="thirdVesselType" [options]="vesselTypes"
                            [formatter]="vesselTypesFormatter">
                </app-select>
              </app-form-group>
              @if (exemption.thirdVesselType === 'IMO') {
                <app-form-group>
                  <app-info class="formGroupLabel">
                    <label>Third vessel name/IMO number</label>
                    <div class="tooltipContent">Name of moored vessel 3</div>
                  </app-info>
                  <app-search [(ngModel)]="thirdVessel" (ngModelChange)="onVesselChangeWithPrefix('third', thirdVessel)"
                              [searchFunction]="searchVessel" [inputFormatter]="vesselNameFormatter"
                              [minCharacters]="3" dataKey="imoCode" id="thirdVessel">
                  </app-search>
                </app-form-group>
              }
            </div>
            <div class="row">
              @if (exemption.thirdVesselType === 'IMO') {
                <app-form-group label="Third vessel name">
                  <input [(ngModel)]="exemption.thirdVesselNameIMO" id="thirdVesselNameIMO" type="text"
                         maxlength="64"
                         class="form-control" readonly required>
                </app-form-group>
              }
              @if (exemption.thirdVesselType === 'IMO') {
                <app-form-group label="Third vessel IMO">
                  <input [(ngModel)]="exemption.thirdVesselIMO" id="thirdVesselIMO" type="text" maxlength="64"
                         class="form-control" readonly required>
                </app-form-group>
              }
              @if (exemption.thirdVesselType === 'ENI') {
                <app-form-group label="Third vessel name">
                  <input [(ngModel)]="exemption.thirdVesselNameENI" id="thirdVesselNameENI" type="text"
                         maxlength="64" class="form-control" required>
                </app-form-group>
              }
              @if (exemption.thirdVesselType === 'ENI') {
                <app-form-group label="Third vessel ENI">
                  <input [(ngModel)]="exemption.thirdVesselENI" id="thirdVesselENI" type="text" maxlength="64"
                         class="form-control" required>
                </app-form-group>
              }
            </div>
          </div>
        }

        @if (exemption.thirdVesselType) {
          <div>
            <div class="row">
              <div class="label mb-2">Third vessel berthing/admission time</div>
            </div>
            <div class="row">
              <app-form-group>
                <app-info class="formGroupLabel">
                  <label>From</label>
                  <div class="tooltipContent">From when the vessel is berthed next to the ‘base vessel’</div>
                </app-info>
                <app-date-field [(ngModel)]="exemption.thirdVesselFrom" id="thirdVesselFrom" required></app-date-field>
              </app-form-group>
              <app-form-group>
                <app-info class="formGroupLabel">
                  <label>To</label>
                  <div class="tooltipContent">To when the vessel is berthed next to the ‘base vessel’</div>
                </app-info>
                <app-date-field [(ngModel)]="exemption.thirdVesselTo" id="thirdVesselTo" required></app-date-field>
              </app-form-group>
            </div>
          </div>
        }

        <div class="row">
          <app-form-group label="Substance (Proper shipping name)">
            <app-search [(ngModel)]="dangerousGoods" dataKey="name"
                        (ngModelChange)="onDangerousGoodsChange(dangerousGoods)"
                        [inputFormatter]="portVisitUtils.dangerousGoodsFormatter"
                        [searchFunction]="portVisitUtils.findDangerousGoods"
                        [resultFormatter]="portVisitUtils.dangerousGoodsFormatter"
                        placeholder="Find by name or UN code">
            </app-search>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Substance name">
            <textarea [(ngModel)]="exemption.substanceName" id="substanceName" type="text" rows="3" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="row">
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>UN number</label>
              <div class="tooltipContent">If unknown select 0000</div>
            </app-info>
            <input [(ngModel)]="exemption.unVnNumber" id="unVnNumber" type="text" maxlength="256"
                   class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Reason for request for exemption</label>
              <div class="tooltipContent">A minimum of 20 characters is required</div>
            </app-info>
            <textarea [(ngModel)]="exemption.reason" id="reason" type="text" rows="3" minlength="20" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" id="details" type="text" rows="3" maxlength="256"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
